import { useNavigate } from "react-router-dom";
import { AllProjects } from "@/components/AllProjects";
import { Header } from "@/components/Header";

const Projects = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header
        onNewProject={() => navigate("/new-project")}
        onViewProjects={() => navigate("/projects")}
      />

      <main className="container mx-auto px-4 py-6">
        <AllProjects
          onBack={() => navigate("/dashboard")}
          onNewProject={() => navigate("/new-project")}
          onViewProject={(projectId) => navigate(`/projects/${projectId}`)}
        />
      </main>
    </div>
  );
};

export default Projects;
